<template>
  <el-carousel id="container" trigger="click" height="520px">
    <el-carousel-item v-for="image in images" :key="image.id">
      <div class="image"
        :style="{
          background: 'url(' + image.path + ') no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover'}"
      >
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>

export default {
  name: 'Swiper',
  data () {
    return {
      activeIndex: '1',
      images: []
    }
  },

  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.images = [
        {
          id: 'banner1',
          path: require('../../assets/images/home/banner4.jpg')
        },
        {
          id: 'banner2',
          path: require('../../assets/images/home/banner5.jpg')
        },
        {
          id: 'banner3',
          path: require('../../assets/images/home/stone1.jpg')
        },
        {
          id: 'banner4',
          path: require('../../assets/images/home/stone2.jpg')
        }
      ]
    }
  },
  computed: {
    bannerHeight () {
      return '35rem'
    }
  }

}
</script>

<style lang="less" scoped>
#container .image {
  width: 100%;
  height: 100%;
}
</style>
